import Tracker from "./Tracker.js";
/**
 * Creates and initialized the Tracker
 */
export default {
  id: 'molten.TrackerInit',
  sort: -10,
  // needs to be after router

  init: molten => {
    const history = molten.get('history');
    Tracker.init({
      history
    });
    Tracker.pageView(history.location);
  }
};